<template>
	<div class="h-100">
		<div class="loader_calendar w-100 text-center pt-5 mt-5" v-if="!is_load">
			<sync-loader :loading="true" color="#7a59ad" size="10px"></sync-loader>
		</div>

		<div class="calendar_block d-flex flex-column h-100" v-else>
			<div class="h-auto">
				<table class="table table-bordered table-calendar m-0 w-100 h-100 border-0">
					<tr class="text-center">
						<th v-for="day_name in days_name">
							{{ day_name }}
						</th>
					</tr>

					<tr v-for="week in month_data">
						<td v-for="day in week"
							:class="{'text-muted bg-faded' : !day.is_enable, 'bg-primary-300 pattern-0' : day.is_active}"
							v-on:click="set_active_day(day)">
							<i class="fal fa-birthday-cake mt-1 ml-1 position-absolute pos-left pos-top text-primary"
							   v-if="has_birthday(day)"></i>

							<div class="cursor-pointer">
								{{ day.date_number }}
							</div>
						</td>
					</tr>
					<!--
							<td>2</td>
							<td>3</td>
							<td class="bg-primary-300 pattern-0">4</td>
							<td>5</td>
							<td><i class="fal fa-birthday-cake mt-1 ml-1 position-absolute pos-left pos-top text-primary"></i> 6</td>

							-->
				</table>
			</div>
			<div class="flex-1 custom-scroll">
				<div class="p-2">

					<div class="d-flex align-items-center text-left mb-3">
						<div class="width-5 fw-300 text-primary l-h-n mr-1 align-self-start fs-xxl"
							 v-if="active_day != undefined">
							{{ active_day.date_number }}
						</div>

						<div class="flex-1">
							<div class="d-flex flex-column" v-if="active_day != undefined">
                                <span class="l-h-n fs-md fw-500 opacity-70">
                                    {{ active_day.month_name }} {{ active_day.year }}
                                </span>
								<span class="l-h-n fs-nano fw-400 text-secondary">
                                     {{ active_day.full_name }}
                                </span>
							</div>


						</div>
					</div>

					<div class="mt-3" v-if="active_day != undefined">
						<div class="d-flex align-items-center border-bottom pt-2 pb-2"
							 v-for="user in active_day.birthdays" v-on:click="show_user(user)">
                            <span class="status mr-2">
                                <span class="profile-image-md rounded-circle d-inline-block" v-bind:style="{
                                      'background-image': 'url(' + user.medium_img + ')',
                                      'background-size': 'cover'
                                       }">
                                </span>
                            </span>

							<span class="d-flex flex-column flex-1 ml-1">
                                    <span class="name">{{ user.name }}</span>
                                    <span class="msg-a fs-sm">{{ user.company }}
                                        <small>{{ user.dolznost }}</small>
                                    </span>
                                    <span class="fs-nano text-muted mt-1">{{ user.data_1c.birthday }}</span>
                             </span>
						</div>

					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'


export default {
	name: "birthday",
	components: {
		SyncLoader,
	},

	created() {
		this.load_calendar();
	},

	data() {
		return {
			is_load: false,
			calendar_url: "/index.php?option=com_imc_docs&task=dashboard.getCalendar",
			calendar_data: [],
		}
	},


	methods: {

		show_user(user) {
			EventBus.$emit('click_user_photo', user.id);
		},

		has_birthday(day) {

			if (day.is_enable && day.hasOwnProperty("birthdays")) {
				if (day.birthdays.length > 0) {
					return true;
				}
			}

			return false;
		},

		async load_calendar() {
			await api.get('dashboard/birthday/month').then(({data}) => {
				this.is_load = true;
				if (data.status === "operation_success") {
					this.calendar_data = data.message;
				} else {
					this.calendar_data = [];
				}
			}).catch(err => {
				this.calendar_data = [];
				this.is_load = false;
			});
		},

		set_active_day(day) {
			if (day.is_enable) {
				this.month_data.map(week => {
					week.map(_day => {
						_day.is_active = false;
						if (_day.is_enable && day.date_number == _day.date_number) {
							_day.is_active = true;
						}
					})
				});
			}
		}
	},
	computed: {

		days_name() {
			return this.calendar_data.week_days_ua;
		},

		month_data() {
			return this.calendar_data.normalize_calendar;
		},

		active_day() {
			if (this.month_data.length > 0) {

				let is_active_day = null;
				this.month_data.map(week => {
					week.map(day => {
						if (day.is_active) {
							is_active_day = day;
						}
					})
				});

				return is_active_day;
			}
		}

	}
}
</script>

<style scoped>

</style>
